import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import AppSection from './components/AppSection';
import AboutSection from './components/AboutSection';
import MediaSection from './components/MediaSection';
import TopicsSection from './components/TopicsSection';
import CommentsSection from './components/CommentsSection';
import ContactSection from './components/ContactSection';
import RankingSection from './components/RankingSection';
import CarouselSection from './components/CarouselSection';
import IndexSection from './components/IndexSection';
import FaqSection from './components/FaqSection';
import UpdatesSection from './components/UpdatesSection';
import CardsSection from './components/CardsSection';
import FeaturesSection from './components/FeaturesSection';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <HeroSection />
        <AppSection />
        <AboutSection />
        <MediaSection />
        <TopicsSection />
        <CommentsSection />
        <ContactSection />
        <RankingSection />
        <CarouselSection />
        <IndexSection />
        <FaqSection />
        <UpdatesSection />
        <CardsSection />
        <FeaturesSection />
      </main>
      <Footer />
    </>
  );
}